import { FC } from 'react';
import { faSquare } from '@fortawesome/pro-regular-svg-icons';
import { faSquareCheck, faSquareMinus } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { CheckboxElement } from 'framework/checkbox/elements';
import { useCheckboxTheme } from 'framework/checkbox/hooks/useCheckboxTheme';
import { FieldWrapper } from 'framework/field/components/FieldWrapper';
import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';
import { Icon } from 'framework/Icon';
import { Label } from 'framework/label';

import { EMPTY_FUNCTION } from '../../constants';

import { CheckboxProps } from './types';

import cn from './Checkbox.module.scss';

export const Checkbox: FC<CheckboxProps> = ({
  label = '',
  information = '',
  height = '32px',
  width = 'fit-content',
  padding = '0px',
  onClick = EMPTY_FUNCTION,
  checked = false,
  disabled = false,
  left_label = '',
  right_label = '',
  theme,
}) => {
  const field_theme = useFieldTheme(theme?.field);
  const checkbox_theme = useCheckboxTheme(theme?.checkbox);

  const icon_size = checkbox_theme.general.icon_size;
  return (
    <FieldWrapper
      label={label}
      information={information}
      width={width}
      padding={padding}
      theme={field_theme.general}
    >
      <CheckboxElement
        role="checkbox"
        className={classNames(cn.checkbox, { [cn.disabled]: disabled })}
        aria-checked={!!checked}
        data-disabled={disabled}
        theme={{ field: field_theme, checkbox: checkbox_theme }}
        onClick={() => {
          if (!disabled) onClick(!checked);
        }}
        style={{ height }}
      >
        <Label label={left_label} theme={field_theme.general} button />
        {checked && <Icon icon={faSquareCheck} width="fit-content" size={icon_size} button />}
        {checked === false && <Icon icon={faSquare} width="fit-content" size={icon_size} button />}
        {checked === null && (
          <Icon icon={faSquareMinus} width="fit-content" size={icon_size} button />
        )}
        <Label label={right_label} theme={field_theme.general} button />
      </CheckboxElement>
    </FieldWrapper>
  );
};
